/**
 * Created by administrator on 2019/4/24.
 */
const getters = {
  userName(state) {
    return state.user.name
  }
}

export default getters
